module.exports = __webpack_public_path__ + "img/statuatoryReport.d1aa1440.svg";